module.exports = __webpack_public_path__ + "static/media/screen_1.271681aa.png";